import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
export function Hero() {
  return <section className="pt-6 pb-8 px-4 md:pt-32 md:pb-20 max-w-6xl mx-auto text-center md:min-h-0 min-h-[100svh] flex flex-col justify-center" data-id="element-118">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-119">
        <p className="text-[11px] sm:text-sm md:text-base uppercase tracking-[0.2em] font-bold text-terracota mb-2 md:mb-4" data-id="element-120">
          Profe Listo · Yoga 360
        </p>

        <h1 className="text-[26px] leading-[1.15] sm:text-4xl md:text-6xl lg:text-7xl font-extrabold text-oscuro mb-3 md:mb-6" data-id="element-121">
          Todo tu año de yoga
          <br data-id="element-122" />
          resuelto de una vez.
        </h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative max-w-[200px] sm:max-w-md md:max-w-2xl mx-auto mb-3 md:mb-8" data-id="element-123">
          <img src="https://cdn.magicpatterns.com/uploads/hrmBaCcaDSCsF1c2EqVJpr/173.png" alt="Megapack YOGA 360 — Pack Anual Elite Completo" className="w-full h-auto" width={1000} height={1200}
        // @ts-ignore
        fetchpriority="high" decoding="async" data-id="element-124" />
        </motion.div>

        <h2 className="text-[13px] leading-snug sm:text-lg md:text-2xl text-gray-600 mb-3 md:mb-8 max-w-3xl mx-auto md:leading-relaxed" data-id="element-125">
          Megapack YOGA 360 — El sistema completo
          <br className="hidden md:block" data-id="element-126" />
          de secuencias y planificación para el
          <br className="hidden md:block" data-id="element-127" />
          profesor de yoga argentino
        </h2>

        <div className="flex flex-wrap justify-center items-center gap-1.5 md:gap-4 text-[11px] sm:text-sm md:text-base font-medium text-oscuro mb-4 md:mb-10" data-id="element-128">
          <span className="flex items-center gap-1 bg-white px-2.5 py-1 md:px-4 md:py-2 rounded-full shadow-sm" data-id="element-129">
            📄 PDF
          </span>
          <span className="hidden md:inline text-gray-300" data-id="element-130">|</span>
          <span className="flex items-center gap-1 bg-white px-2.5 py-1 md:px-4 md:py-2 rounded-full shadow-sm" data-id="element-131">
            ⚡ Acceso Inmediato
          </span>
          <span className="hidden md:inline text-gray-300" data-id="element-132">|</span>
          <span className="flex items-center gap-1 bg-white px-2.5 py-1 md:px-4 md:py-2 rounded-full shadow-sm" data-id="element-133">
            📚 12 Tomos + 6 Bonus + 2 Élite
          </span>
        </div>

        <div className="flex flex-col items-center" data-id="element-134">
          <Button href="#elegi-tu-pack" onClick={e => {
          e.preventDefault();
          const el = document.getElementById('elegi-tu-pack');
          if (el) {
            el.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }} className="text-sm sm:text-lg md:text-2xl py-3 md:py-5 px-5 md:px-10 mb-3 md:mb-6 w-full md:w-auto" data-id="element-135">
            💪 QUIERO MI YOGA 360 AHORA
          </Button>

          <div className="flex flex-wrap justify-center items-center gap-2 md:gap-6 text-[10px] sm:text-sm text-gray-500" data-id="element-136">
            <span className="flex items-center gap-1" data-id="element-137">🛡️ Garantía 7 días</span>
            <span className="hidden md:inline text-gray-300" data-id="element-138">|</span>
            <span className="flex items-center gap-1" data-id="element-139">🔒 Pago seguro</span>
            <span className="hidden md:inline text-gray-300" data-id="element-140">|</span>
            <span className="flex items-center gap-1" data-id="element-141">
              💳 Tarjetas y transferencia
            </span>
          </div>
        </div>
      </motion.div>
    </section>;
}